import { render, staticRenderFns } from "./c-alert-overlay.vue?vue&type=template&id=020edb84&scoped=true&"
import script from "./c-alert-overlay.vue?vue&type=script&lang=js&"
export * from "./c-alert-overlay.vue?vue&type=script&lang=js&"
import style0 from "./c-alert-overlay.vue?vue&type=style&index=0&id=020edb84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020edb84",
  null
  
)

export default component.exports